import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Proof() {
  return <section className="py-24 bg-emerald-900 text-ivory" data-id="element-135">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-136">
        <FadeIn data-id="element-137">
          <span className="text-gold font-sans text-xs font-bold tracking-[0.2em] uppercase mb-6 block" data-id="element-138">
            Proof / Believability
          </span>
          <h2 className="text-3xl md:text-4xl font-serif text-gold mb-12" data-id="element-139">
            What changes in 7 days:
          </h2>
        </FadeIn>

        <div className="space-y-8 text-left max-w-2xl mx-auto" data-id="element-140">
          <FadeIn delay={0.1} direction="up" data-id="element-141">
            <div className="flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-6 border-b border-gold/20 pb-6" data-id="element-142">
              <span className="font-serif text-xl text-gold min-w-[100px]" data-id="element-143">
                By day one,
              </span>
              <p className="text-lg font-sans font-light text-ivory/90" data-id="element-144">
                your transit is seamless.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} direction="up" data-id="element-145">
            <div className="flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-6 border-b border-gold/20 pb-6" data-id="element-146">
              <span className="font-serif text-xl text-gold min-w-[100px]" data-id="element-147">
                By day three,
              </span>
              <p className="text-lg font-sans font-light text-ivory/90" data-id="element-148">
                you are being greeted by name at your local café.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} direction="up" data-id="element-149">
            <div className="flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-6 pb-2" data-id="element-150">
              <span className="font-serif text-xl text-gold min-w-[100px]" data-id="element-151">
                By day seven,
              </span>
              <p className="text-lg font-sans font-light text-ivory/90" data-id="element-152">
                you are navigating regional social cues that most expats take
                years to learn.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}